import { useSyncExternalStore, type ReactNode } from 'react';
import { CRM_SUPPORT_SITE } from '@crm/shared/publisher-support-conversation';
import { useTranslation } from 'react-i18next';
import { SupportChat } from '@crm/frontend-core/support/SupportChat';
import * as api from '@crm/frontend-core/support/api';
import { formatSupportDateTime } from '@crm/frontend-core/support/formatDateTime';
import '@crm/frontend-core/support/support-chat.css';
import { CRYPTOLOGY_CONTACT } from '../config/cryptologyContact';

function subscribeToNothing(): () => void {
  return () => undefined;
}

export function LunaSupportChat(): ReactNode {
  const { i18n } = useTranslation('common');
  // The chat restores its open state from browser storage, which the build-time
  // render cannot know. It is left out of that render and of the first browser
  // pass, then mounted, so both produce the same markup.
  const isBrowser = useSyncExternalStore(
    subscribeToNothing,
    () => true,
    () => false
  );
  const locale = i18n.language.startsWith('en') ? 'en-GB' : 'es-PE';
  if (!isBrowser) {
    return null;
  }
  return (
    <SupportChat
      language={i18n.language}
      api={api}
      siteName={CRM_SUPPORT_SITE.name}
      contactEmail={CRYPTOLOGY_CONTACT.email}
      privacyUrl="/privacy"
      formatDateTime={(value: string): string =>
        formatSupportDateTime(value, locale)
      }
      includePageContext={false}
    />
  );
}
